var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M0 0.5H1.45615C2.425 0.5 3.33421 0.967897 3.89735 1.75629L11.7072 12.6901C12.4751 13.7651 12.4494 15.2158 11.6439 16.2629L3.90067 26.3291C3.33278 27.0674 2.4542 27.5 1.5228 27.5H0",
    stroke: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M19 0.5H11.9556C9.4917 0.5 8.07836 3.30579 9.54495 5.28568L14.6773 12.2143C15.463 13.2751 15.463 14.7249 14.6773 15.7857L9.54495 22.7143C8.07836 24.6942 9.4917 27.5 11.9556 27.5H19",
    stroke: "#DFE2E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrow);
export default __webpack_public_path__ + "static/media/NewArrow.6c6c382c367289449e93d60c13eb2ad8.svg";
export { ForwardRef as ReactComponent };